<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso detalles del vehículo (OT {{ idcotizacionvehiculo }})</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
    	<div class="content-boxed bg-gray1-dark" style="overflow: auto;">

				<table width='100%' class="bg-gray1-dark">
					<tr>
						<td width='30%' class="row bg-gray1-dark"></td>
						<td class="row bg-gray1-dark">
							

						</td>
						<td width='30%' class="row bg-gray1-dark"></td>
					</tr>

					<tr>
						<td width='30%' class="row bg-gray1-dark">
							<div class="row bg-gray1-dark">
								<div class="col-3 mt-2">
									<button ref="greenpen"  @click="greenpen" class="button button-s button-3d shadow-small button-circle bg-green1-dark">
										<i class="fa fa-pen"></i>
										Leve
									</button>
								</div>
								<br>
								<div class="col-3 mt-2">
									<button  ref="yellowpen" @click="yellowpen" class="button button-s shadow-small button-circle bg-yellow1-light">
										<i class="fa fa-pen"></i>
										Medio
									</button>
								</div>
								<br>
								<div class="col-3 mt-2">
									<button  ref="redpen" @click="redpen" class="button button-s shadow-small button-circle bg-red1-light">
										<i class="fa fa-pen"></i>
										Grave
									</button>

								</div>

								<br>
								<br>
								<br>
								<br>
								<div class="col-3 mt-2">
									<button  @click="undo" class="button button-s shadow-small button-circle bg-blue2-light">
										<i class="fa fa-undo"></i>
										Anterior
									</button>
								</div>
								<div class="col-3 mt-2">
									<button  @click="undoimage" class="button button-s shadow-small button-circle bg-dark1-dark">
										<i class="fa fa-times"></i>
										Limpiar imagen
									</button>
								</div>

							</div>
						</td>
						<td  class="row bg-gray1-dark">
								<div style="text-align: right">
								<VueSignaturePad
									id="signature"
									width="700px"
									height="375px"
									ref="signaturePad"
								/>
								</div>

						</td>
					</tr>


				

				</table>

  			
 


    	</div>
		
		<form onsubmit="event.preventDefault();" id="FormsubmitCarroceria">
		
			<div class="content-boxed">
				<div class="content">
					<div v-if="c.cols" v-for="(c, index) in caracteristicas" class="content-boxed shadow-large bg-mint-light">
						<div class="content bottom-0">
							<h3 class="bolder">{{ c.descripcion }}</h3>
							<p>
							<span>
								<input type=hidden v-bind:name="c.iddtype" v-bind:id="c.iddtype" v-bind:value="c.tipocampo">
								<textarea type=input class='form-control'  v-bind:id="c.iddfield" v-bind:name="c.iddfield" v-bind:rows="7" v-bind:cols="c.cols" style="width:100%">{{ c.value.replace(/<br>/g,'\n') }}</textarea>
							</span>

							<input type="hidden" v-bind:id="c.id" v-bind:name="c.name" value=''>
							<span v-if="c.requerido" v-bind:id="'r_mt_cbo_'+c.codtipocaracteristica" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Dato requerido</span>
							</p>
						</div>   
					</div>
				</div>
			</div>
			
		</form>
		 
		<div class="content-boxed">
			  <div class="content bottom-0">
                <div class="contact-form">
                    <form class="contactForm" id="Formsubmit">
                        <fieldset>
                            <div class="form-button">
                                <a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente" data-formId="dataForm">Siguiente</a>
                            </div>
                        </fieldset>
                    </form>			
                </div>
            </div>
    	</div>
		
    </div>


</template>

<style scoped>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image:url(./../../assets/images/imagenfondoservicio.png),
  linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-size:700px;
  background-origin: border-box;
  background-clip: content-box, border-box;
}

</style>


<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";

import VueSignaturePad from 'vue-signature-pad';

export default {
  data() {
      return {
		  params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO","entity":"8","classifications":"39,40"}',
		  idcotizacionvehiculo:0,
		  idagenda:0,
		  data:
		  {
			  placapatente:'placa',
			  fechaprimeraventa:'fechaprimeraventa',
			  kilometraje:0,
			  tipotrabajo:0,
			  tipoOT:0,
			  fechaentrega:0,
			  horaentrega:0
		  },
		  caracteristicas:[]
		}
    },

	created() {      
		this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"  
		this.idcotizacionvehiculo=localStorage.getItem('idcotizacionvehiculo');
		this.idagenda=localStorage.getItem('idagenda');

		db.getFx2("ot.getcaracteristicas", this.params).then(result => {
			if (result.data.err != "") { alert(result.data.err); console.log(result.data.err); } else {
				this.caracteristicas = result.data.data;

			}
		});
	},

	mounted(){
		this.greenpen();		
	},

  methods: {
	  undoimage() {
		this.$refs.signaturePad.clearSignature();
		this.greenpen();		

		  //window.location="/Wizardot4draw"
		  
      		//this.$refs.signaturePad.fromDataURL('./../../assets/images/imagenfondoservicio.png')
      },
      undo() {
        this.$refs.signaturePad.undoSignature();
      },
      greenpen() {
        this.$refs.signaturePad.options = {
          penColor: "#8cc152"
		};
		this.$refs.greenpen.className="button button-s button-3d shadow-small button-circle bg-green1-dark"
		this.$refs.yellowpen.className="button button-s shadow-small button-circle bg-yellow1-light"
		this.$refs.redpen.className="button button-s shadow-small button-circle bg-red1-light"
		this.$refs.blackpen.className="button button-s shadow-small button-circle bg-dark2-light"		
      },
      redpen() {
        this.$refs.signaturePad.options = {
          penColor: "#d8334a"
        };
		this.$refs.greenpen.className="button button-s shadow-small button-circle bg-green1-dark"
		this.$refs.yellowpen.className="button button-s shadow-small button-circle bg-yellow1-light"
		this.$refs.redpen.className="button button-s button-3d shadow-small button-circle bg-red1-light"
		this.$refs.blackpen.className="button button-s shadow-small button-circle bg-dark2-light"		
      },
      yellowpen() {
        this.$refs.signaturePad.options = {
          penColor: "#ffce54"
        };
		this.$refs.greenpen.className="button button-s shadow-small button-circle bg-green1-dark"
		this.$refs.yellowpen.className="button button-s button-3d shadow-small button-circle bg-yellow1-light"
		this.$refs.redpen.className="button button-s shadow-small button-circle bg-red1-light"
		this.$refs.blackpen.className="button button-s shadow-small button-circle bg-dark2-light"		
      },

      blackpen() {
        this.$refs.signaturePad.options = {
          penColor: "#000000"
        };
		this.$refs.greenpen.className="button button-s shadow-small button-circle bg-green1-dark"
		this.$refs.yellowpen.className="button button-s shadow-small button-circle bg-yellow1-light"
		this.$refs.redpen.className="button button-s shadow-small button-circle bg-red1-light"
		this.$refs.blackpen.className="button button-s button-3d shadow-small button-circle bg-dark2-light"		
      },


	 clear(){
  		this.$refs.signaturePad.clear();
	  },

	  siguiente() {
		  const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
		  if (data != null) {

			  db.getFx2("ot.saveimagevehiculo", '{"idcotizacionvehiculo":"' + this.idcotizacionvehiculo + '","data":"' + data + '"}').then(result => {
				  if (result.data.err != "") { alert(result.data.err); console.log(result.data.err); } else {

					  var strErr = validate.check(FormsubmitCarroceria);
					  console.log(FormsubmitCarroceria);
					  console.log(this.params);
					  if (strErr == "") {
						  db.sendDataForm2(FormsubmitCarroceria, this.params).then(result => {
							  if (result.data.err != "") { alert(result.data.err); console.log(result.data.err); } else {
								//   window.location = "/Wizardot5datadetail"
								  window.location="/Wizardot4takephotos"
							  }
						  });

					  } else {
						  console.log("Error")
					  }

				  }
			  });
		  }
	  }



  }
}

</script>
